import React, { useState } from 'react';
import { FaFileDownload, FaFileCsv, FaFileCode } from 'react-icons/fa';

/**
 * Componente para exportação de dados de histórico e estatísticas
 */
const ExportDataButton = ({ history, stats, filters }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  // Função para exportar dados em formato CSV
  const exportAsCSV = () => {
    setIsExporting(true);
    
    try {
      // Cabeçalhos para o CSV
      const headers = [
        'Round',
        'Position',
        'Amount',
        'Result',
        'Payout',
        'Lock Price',
        'Close Price',
        'Timestamp'
      ].join(',');
      
      // Linhas de dados
      const rows = history.map(entry => [
        entry.epoch,
        entry.position,
        entry.amount,
        entry.won ? 'Won' : 'Lost',
        entry.payout,
        entry.lockPrice,
        entry.closePrice,
        entry.timestamp || ''
      ].join(','));
      
      // Adicionar estatísticas resumidas ao final
      const statsRows = [
        '',
        '--- STATISTICS ---',
        `Total Bets,${stats.totalBets}`,
        `Wins,${stats.totalWins}`,
        `Losses,${stats.totalLosses}`,
        `Win Rate,${stats.winRate}%`,
        `Total Bet Amount,${stats.totalBetAmount}`,
        `Total Won Amount,${stats.totalWinAmount}`,
        `Profit/Loss,${stats.profitLoss}`,
        `ROI,${stats.profitPercentage}%`
      ];
      
      // Adicionar informações de filtro
      const filterRows = [
        '',
        '--- FILTERS APPLIED ---',
        `Time Range,${filters.timeRange}`,
        `Position,${filters.position}`,
        `Outcome,${filters.outcome}`
      ];
      
      // Combinar tudo
      const csvContent = [
        headers,
        ...rows,
        ...statsRows,
        ...filterRows
      ].join('\n');
      
      // Criar blob e link para download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      
      // Configurar e simular clique no link
      link.setAttribute('href', url);
      link.setAttribute('download', `bull-vs-bear-history-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setShowOptions(false);
    } catch (error) {
      console.error('Error exporting CSV:', error);
    } finally {
      setIsExporting(false);
    }
  };
  
  // Função para exportar dados em formato JSON
  const exportAsJSON = () => {
    setIsExporting(true);
    
    try {
      // Criar objeto com todos os dados
      const exportData = {
        metadata: {
          exportDate: new Date().toISOString(),
          filters: filters
        },
        statistics: stats,
        history: history
      };
      
      // Converter para string JSON
      const jsonContent = JSON.stringify(exportData, null, 2);
      
      // Criar blob e link para download
      const blob = new Blob([jsonContent], { type: 'application/json;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      
      // Configurar e simular clique no link
      link.setAttribute('href', url);
      link.setAttribute('download', `bull-vs-bear-history-${new Date().toISOString().split('T')[0]}.json`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setShowOptions(false);
    } catch (error) {
      console.error('Error exporting JSON:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowOptions(!showOptions)}
        disabled={isExporting || history.length === 0}
        className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium transition-colors ${
          history.length === 0
            ? 'bg-gray-700/50 text-gray-500 cursor-not-allowed'
            : 'bg-[#7900ff]/20 text-[#7900ff] hover:bg-[#7900ff]/30'
        }`}
      >
        <FaFileDownload size={12} />
        {isExporting ? 'Exporting...' : 'Export Data'}
      </button>
      
      {showOptions && (
        <div className="absolute right-0 mt-2 w-48 bg-[#1a1a1a] rounded-lg shadow-lg border border-[#7900ff]/30 z-10">
          <div className="p-2">
            <button
              onClick={exportAsCSV}
              className="w-full flex items-center gap-2 px-3 py-2 rounded hover:bg-[#7900ff]/20 transition-colors text-left"
            >
              <FaFileCsv className="text-green-500" />
              <span>Export as CSV</span>
            </button>
            
            <button
              onClick={exportAsJSON}
              className="w-full flex items-center gap-2 px-3 py-2 rounded hover:bg-[#7900ff]/20 transition-colors text-left"
            >
              <FaFileCode className="text-blue-500" />
              <span>Export as JSON</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportDataButton;
